import React, { useEffect, useState } from 'react';
import { Navigate, Routes, Route, useParams } from 'react-router-dom';
import { querystring } from '../../utils/helpers';
import AssessmentsAnswerView from '../Assessments/AssessmentsAnswerView';
import { useStores } from '../../hooks/use-stores';
import { observer } from 'mobx-react';
import PackageLoader from './PackageLoader';
//https://awarego.ngrok.io/cmi5/1/course/ae5a3366-f591-47cb-ace6-aced167c73cb/T8EMoFxj12IW3ZAo0evc2fSHV3ncp9shsJsGrfY51NYtajT5zC/au/0

const RXD = window.parent.RXD;

function RXDHome() {
    const { companyId, uniqueId, accessKey, auId } = useParams();
    const { authStore, cmi5Store, brandingStore } = useStores();
    const [ready, setReady] = useState();
    const { cmiUser } = cmi5Store;

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        initRXD();
    }, []);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        cmi5Store.setCompanyId(companyId);
        cmi5Store.setContext({ accessKey, auId: Number(auId) });
        brandingStore.setCustomBranding(companyId, accessKey);
        setReady(true);
    }, [companyId]);

    const initRXD = () => {
        if (RXD) {
            authStore.forgetUser();

            cmi5Store.setRXD(RXD);
        }
    };

    const AssessmentAnswersView = () => {
        let questionIndex = querystring('index');
        return (
            <AssessmentsAnswerView
                companyId={companyId}
                assessmentId={uniqueId}
                currentUser={cmiUser}
                questionStore={cmi5Store}
                assessmentStore={cmi5Store}
                index={questionIndex}
            />
        );
    };

    const RedirectToAnswers = () => {
        let questionIndex = querystring('index');
        const query = questionIndex ? `?index=${questionIndex}` : '';
        return <Navigate to={`assessment/answers${query}`} />;
    };

    return (
        ready && (
            <Routes>
                <Route
                    path="assessment/answers"
                    element={<AssessmentAnswersView />}
                />

                <Route
                    path=":id/answers"
                    element={<RedirectToAnswers />}
                />
                <Route
                    path="*"
                    element={
                        <PackageLoader
                            companyId={companyId}
                            uniqueId={uniqueId}
                            accessKey={accessKey}
                            auId={auId}
                        />
                    }
                />
            </Routes>
        )
    );
}

export default observer(RXDHome);
